import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import { RackCellSchema } from "@redotech/redo-model/wms/schema/warehouse-cell";
import * as z from "zod";

const BinWithInventorySchema_ = z.object({
  binName: z.string(),
  totalQuantity: z.number(),
});
export const BinWithInventorySchema: z.ZodType<BinWithInventory> =
  BinWithInventorySchema_;
export interface BinWithInventory extends z.infer<
  typeof BinWithInventorySchema_
> {}

export const checkWarehouseLayoutInventoryConflicts = {
  name: "checkWarehouseLayoutInventoryConflicts" as const,
  input: z.object({
    crdbLocationId: locationIdFormat.schema,
    racks: z.record(z.string(), RackCellSchema),
  }),
  output: z.object({
    hasConflicts: z.boolean(),
    binsWithInventory: z.array(BinWithInventorySchema),
  }),
};
